<script>
import axios from '@/utils/axios';

export default {
 inject: ['setLoading'],
 data() {
  return {
    title: "CRM",
    text: "CRM",
    search: '',
    tableColumns: [
      { key: 'file_number', label: 'File Number' },
      { key: 'name', label: 'Name' },
      { key: 'mobile', label: 'Mobile' },
      // { key: 'address', label: 'Address' },
      { key: 'order_date', label: 'Order Date' },
      { key: 'dispatch_date', label: 'Dispatch Date' },
      { key: 'windows_qty', label: 'Windows Qty' },
      { key: 'glass_status', label: 'Glass Status' },
      { key: 'delivery_status', label: 'Delivery Status' },
      { key: 'actions', label: 'Actions' },
    ],
    data: [],
    pagination: {
     current_page: 1,
     per_page: 50,
     last_page: 1,
     total: 0,
     links: []
    },
   };
  },

  computed: {
   text1(){
    return `Customer Dispatch (${this.pagination.total})`;
   }, 
  //  serialNo(){
  //   return (this.pagination.current_page - 1) * this.pagination.per_page;
  //  } 
  },

  mounted(){
   this.fetchDispatches();
  }, 

  methods: {

    statusBadgeClass(status) {
      if (status === 'dispatched') return 'badge-orange';
      if (status === 'ready_for_dispatch') return 'badge-yellow';
      return 'badge bg-secondary';
    },

    statusLabel(status) {
      if (status === 'dispatched') return 'Dispatched';
      if (status === 'ready_for_dispatch') return 'Ready for Dispatch';
      return status;
    },
    
    async fetchDispatches(page = 1) {
     this.setLoading(true);
     try{
      const params = {
       page,
       search: this.search.trim() || '' 
      };
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/customer-dispatches?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    // changePage(url){
    //  if (!url) return;
    //  const page = new URL(url).searchParams.get("page");
    //  this.fetchDispatches(page);
    // },

   clearFilter(){
    this.search = '';
    this.fetchDispatches();
   },

   formatDate(date) {
    if (!date) return '-';
    const d = new Date(date);
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
   },

   // ===== Modal openers =====
   async openViewDispatch(id) {
     await this.$refs.dispatchModal.openView(id);
     this.$openModal('customer_dispatch_modal');
   },

   async openEditDispatch(id) {
     await this.$refs.dispatchModal.openEdit(id);
     this.$openModal('customer_dispatch_modal');
   },

   openAddDispatch() {
     this.$refs.dispatchModal.openCreate();
     this.$openModal('customer_dispatch_modal');
   },

   openDeleteDispatch(row) {
     this.$refs.dispatchModal.openDelete(row);
     this.$openModal('customer_dispatch_delete_modal');
   },
    
  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        
        <!-- <div class="mb-2">
          <a href="javascript:void(0);" class="btn btn-primary d-flex align-items-center" @click="openAddDispatch()">
            <i class="ti ti-circle-plus me-2"></i>Add Dispatch
          </a>
        </div>
        -->
      </div>
    </div>
    <!-- /Breadcrumb -->

    <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
    <h5>Customer Dispatch List</h5>
    
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-3" v-if="search">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="search" placeholder="Search...." @keyup.enter="fetchDispatches()"/>
    </div>
    </div>

    <div class="me-3">
     <button type="button" class="btn btn-dark" @click="fetchDispatches()"><i class="ti ti-search"></i></button>
    </div>

    </div>
    
   </div>

<div class="card-body card-table-wrapper">
  <app-table
    :columns="tableColumns"
    :rows="data"
    :pagination="pagination"
    :loading="false"
    :skeleton-rows="5"
    empty-text="No records found."
    empty-icon="ti ti-truck-off"
    @page-change="fetchDispatches"
  >

    <!-- File Number -->
    <template #file_number="{ row }">
      <a href="javascript:void(0);" @click="openViewDispatch(row.id)" class="fw-bold text-primary">{{ row.file_number }}</a>
    </template>

        <!-- Name -->
    <template #name="{ row }">
        {{ row.customer?.name || '-' }}
    </template>

    <!-- Mobile -->
    <template #mobile="{ row }">
        {{ row.customer?.mobile || '-' }}
    </template>

    <!-- Order Date -->
    <template #order_date="{ row }">
      {{ formatDate(row.order_date) }}
    </template>

    <!-- Dispatch Date -->
    <template #dispatch_date="{ row }">
      {{ formatDate(row.dispatch_date) }}
    </template>

    <!-- Windows Qty -->
    <template #windows_qty="{ row }">
      {{ row.windows_quantity }}
    </template>

    <!-- Glass Status -->
    <template #glass_status="{ row }">
      {{ row.glass_status || '-' }}
    </template>

    <!-- Delivery Status -->
    <template #delivery_status="{ row }">
      <span class="badge" :class="statusBadgeClass(row.delivery_status)">{{ statusLabel(row.delivery_status) }}</span>
    </template>

    <!-- Actions -->
    <template #actions="{ row }">
      <div class="dropdown">
        <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="ti ti-dots-vertical"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end p-3">
          <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="openEditDispatch(row.id)"><i class="ti ti-edit me-1"></i>Edit</a>
          </li>
          <li v-if="row.delivery_status === 'ready_for_dispatch'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="$refs.dispatchModal.updateStatus(row.id)"><i class="ti ti-truck-delivery me-1"></i>Mark Dispatched</a>
          </li>
          <li>
            <a class="dropdown-item rounded-1 text-danger" href="javascript:void(0);" @click="openDeleteDispatch(row)"><i class="ti ti-trash me-1"></i>Delete</a>
          </li>
        </ul>
      </div>
    </template>

  </app-table>
</div>
 </div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<customer-dispatch-modal ref="dispatchModal" @updated="fetchDispatches"></customer-dispatch-modal>

</template>

<style scoped>
.badge-yellow {
  background-color: #ffc107;
  color: #000;
}
.badge-orange {
  background-color: #fd7e14;
  color: #fff;
}
   .table-responsive {
        overflow-y: auto;
    }
</style>